/**
 * 未读数 / 角标 / 通知中心 三态同步。**框架里最该用的一个东西。**
 *
 * 三个真实故障，全部出在"这三样各管各的"：
 *
 * 1. 用户看到角标 → 进应用读完 → 角标没了、**横幅还留在通知中心** → 以为还有没看的，
 *    点进来什么都没有。原因：代码里只清了角标，从来没人关过通知。
 *
 * 2. 有一个 markRead **永远兜不住**的时序：消息到达时用户正开着那个会话 → 客户端先标已读
 *    → 推送后到 → 横幅弹出来时未读已经是 0 → 此后再也不会有任何 markRead 发生 →
 *    那条横幅永远留着。唯一的解法是**回到前台时按当前未读数再扫一次**。
 *
 * 3. 关通知时把正在响的来电一起关了 = 漏接电话。持久通知必须排除。
 *
 * 所以这里只暴露一个入口 `set(total)`：角标和通知永远一起动，没有"只清了一个"的可能。
 */
import { setBadge } from './badge.js';
import { notificationsToClose } from './notifications.js';
export function createUnreadController(options) {
    let total = 0;
    async function closeStale(readThreadIds) {
        try {
            const reg = await options.getRegistration();
            if (!reg)
                return;
            const list = await reg.getNotifications();
            const ctx = readThreadIds === undefined ? { unreadTotal: total } : { unreadTotal: total, readThreadIds };
            for (const n of notificationsToClose(list, ctx))
                n.close();
        }
        catch (e) {
            options.onError?.('notifications', e);
        }
    }
    async function applyBadge() {
        const r = await setBadge(total);
        if (r.ok)
            return { total, badge: true };
        options.onFallback?.(total);
        if (r.reason !== 'unsupported')
            options.onError?.('badge', r);
        return { total, badge: false, badgeReason: r.reason };
    }
    const controller = {
        current: () => total,
        async set(next, opts = {}) {
            total = Number.isFinite(next) ? Math.max(0, Math.trunc(next)) : 0;
            // 两件事都要做，且不能因为一件失败就跳过另一件
            const [badge] = await Promise.all([
                applyBadge(),
                closeStale(opts.readThreadIds),
            ]);
            return badge;
        },
        async reconcile() {
            const [badge] = await Promise.all([applyBadge(), closeStale()]);
            return badge;
        },
        start() {
            if (typeof document === 'undefined')
                return () => { };
            const onVisible = () => {
                if (document.visibilityState === 'visible')
                    void controller.reconcile();
            };
            document.addEventListener('visibilitychange', onVisible);
            // 桌面端切窗口不一定触发 visibilitychange，focus 补一刀
            if (typeof window !== 'undefined')
                window.addEventListener('focus', onVisible);
            // 挂载时立刻对一次
            void controller.reconcile();
            return () => {
                document.removeEventListener('visibilitychange', onVisible);
                if (typeof window !== 'undefined')
                    window.removeEventListener('focus', onVisible);
            };
        },
    };
    return controller;
}
//# sourceMappingURL=unread.js.map